import React from 'react';

import styles from './horizontal-bars-tile.module.scss';

type Item = {
  label: string,
  value: number | null,
};

type Props = {
  title: string,
  items: Item[],
  barColor?: string,
};

export default function HorizontalBarsTile({
  title,
  items,
  barColor = '#007D8F',
}: Props) {
  const max = Math.max(...items.map((item) => item.value || 0), 0);
  const safeItems = items.length ? items : [{ label: '-', value: 0 }];

  return (
    <section className={styles.tile}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.body}>
        {safeItems.map((item) => {
          const value = item.value || 0;
          const widthPct = max > 0 ? (value / max) * 100 : 0;
          return (
            <div key={item.label} className={styles.row}>
              <p className={styles.label}>{item.label}</p>
              <div className={styles.barLine}>
                <div
                  className={styles.bar}
                  style={{
                    width: `${Math.max(widthPct, 2)}%`,
                    backgroundColor: barColor,
                  }}
                />
                <span className={styles.value}>{value}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
